import React from 'react';

import TrashSVG from 'Components/Admin/assets/TrashSVG';
import EditSVG from 'Components/Admin/assets/EditSVG';
import ShareSVG from 'Components/Admin/assets/ShareSVG';
import PrintSVG from 'Components/Admin/assets/PrintSVG';

export const buttons = [
  { btnType: 'tertiary', title: 'Shared', svg: <ShareSVG />, fun: () => console.log('Shared') },
  { btnType: 'tertiary', title: 'Edit', svg: <EditSVG />, fun: () => console.log('Edit') },
  { btnType: 'tertiary', title: 'Print', svg: <PrintSVG />, fun: () => console.log('Print') },
  { btnType: 'danger', title: 'Delete', svg: <TrashSVG />, fun: () => console.log('Delete') },
];
